import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function render() {
  const tl = gsap.timeline({
    scrollTrigger: {
      end: window.innerWidth > 1024 ? "bottom" : "+=" + window.innerHeight / 2,
      pin: window.innerWidth > 1024,
      scroller: ".smooth-scroll",
      scrub: true,
      start: "top top",
      trigger: ".l-icon",
    },
  });

  const panels = Array.from(document.querySelectorAll(".c-panel")).reverse();
  let zIndex = 100;

  panels.forEach((panel, i) => {
    const els = [panel.querySelector(".c-panel__half.-is-bottom")];

    if (panels[i + 1]) {
      els.push([panels[i + 1].querySelector(".c-panel__half.-is-top")]);

      tl.to(els, { rotateX: "+=90" })
        .set(panels[i + 1], { zIndex })
        .to(els, { rotateX: "+=90" });

      zIndex += 100;
    }
  });
}
